import Render from '@Views/components/layout/control-bar.html'
import { Vue, Component } from 'vue-property-decorator'

@Render
@Component({})
export class ControlBar extends Vue {}
